export let tableLabels = [{
  label: '受检人',
  value: ''
}, {
  label: '称谓', // 性别
  value: ''
}, {
  label: '样本条码号',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '检测套餐',
  value: 'orderActionData.order.clientProduct.name'
}, {
  label: '联系电话',
  value: ''
}, {
  label: '代理商',
  value: ''
}, {
  label: '申请时间',
  value: ''
}, {
  label: '备注',
  value: ''
}]

export let tableLabelsOk = [{
  label: '受检人',
  value: ''
}, {
  label: '称谓', // 性别
  value: ''
}, {
  label: '样本条码号',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '检测套餐',
  value: 'orderActionData.order.clientProduct.name'
}, {
  label: '联系电话',
  value: ''
}, {
  label: '代理商',
  value: ''
}, {
  label: '申请时间',
  value: ''
}, {
  label: '备注',
  value: ''
}, {
  label: '解读状态',
  value: ''
}]
export let filterFactor = [ {
  label: '解读状态',
  type: 'select',
  clearable: true,
  value: '', // 需返回数据的字段名
  options: [{
    label: '待审核',
    value: '待审核'
  }, {
    label: '审核不通过',
    value: '审核不通过'
  }, {
    label: '待解读',
    value: '待解读'
  }, {
    label: '已解读',
    value: '已解读'
  }]
}]
